// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-o_fP","advertDetailHeaderLocation__value":"c-o_fQ"};